<button
  class="split-main"
  [type]="nativeType()"
  [disabled]="disabled()"
  (click)="buttonClick.emit($event)"
>
  <span class="split-label"><ng-content></ng-content></span>
</button>
<span class="split-divider" aria-hidden="true"></span>
<button
  class="split-trigger"
  type="button"
  [disabled]="disabled()"
  [attr.aria-label]="menuLabel()"
  [cdkMenuTriggerFor]="menu()"
  [cdkMenuPosition]="positions()"
>
  <mdw-icon [icon]="icons.DropdownArrow"></mdw-icon>
</button>
